// These constants match those in the back-end
// NOTE: This file is aligned with:
// - api-lib: src/Infrastructure/ValueObject/Enum/Product.php
// - autoverify-mpm: src/utils/enums/avrProducts.js
// - SDA: js-src/src/utils/mpmProductsEnum.js
// When updating, ensure all files remain synchronized.
const AvrProducts = {
  AVR: 'avr',
  CREDIT: 'credit',
  TRADE: 'trade',
  INSURANCE: 'insurance',
  REVIEWS: 'reviews',
  TEST_DRIVE: 'testDrive',
  ECOMV2: 'ecomV2',
  SPOTLIGHT: 'spotlight',
  PREQUALIFY: 'prequalify',
  INVENTORY_MATCHING: 'inventoryMatching',
  ACQUIRE: 'acquire',
  AI_ASSISTANT: 'aiAssistant',
  IDV: 'identityVerification',
};

const ProductFamilyMap = {
  // This is for product settings
  [AvrProducts.AVR]: [
    AvrProducts.CREDIT,
    AvrProducts.TRADE,
    AvrProducts.INSURANCE,
    AvrProducts.REVIEWS,
    AvrProducts.TEST_DRIVE,
  ],
  standalone: [AvrProducts.ECOMV2, AvrProducts.PREQUALIFY, AvrProducts.IDV],
  // All products except for ecom are grouped together for analytics
  avrAnalytics: [
    AvrProducts.CREDIT,
    AvrProducts.TRADE,
    AvrProducts.INSURANCE,
    AvrProducts.REVIEWS,
    AvrProducts.TEST_DRIVE,
    AvrProducts.SPOTLIGHT,
  ],
};

// Display names for the keys of the business avrProductDetails (as returned by GET /api/business/get).
// Keys are the back-end values, which differ from AvrProducts in places (e.g. 'idv' vs 'identityVerification').
const AvrProductDetailsDisplayNames = {
  acquire: 'Acquire',
  aiAssistant: 'AI Assistant',
  buildAndPrice: 'Build & Price',
  credit: 'Credit+',
  ecomV2: 'E-Commerce',
  idv: 'IDV',
  insurance: 'Insurance',
  reviews: 'Reviews',
  spin: 'Spin',
  spotlight: 'Spotlight',
  testDrive: 'Test Drive',
  trade: 'Trade',
  inventoryMatching: 'Inventory Matching',
  prequalify: 'Pre-qualify',
};

export { AvrProducts, ProductFamilyMap, AvrProductDetailsDisplayNames };
